<template>
  <div>
    <el-image :src="require('@/assets/img/s_top_03.png')" ></el-image>
  </div>
  <el-image :src="require('@/assets/img/bj_ej.png')" style="z-index: -100;position: absolute;"></el-image>
  <div class="bodyDiv">
    <div style="margin-right: 0">
      <!--      传来的参数id值是{{id}}中英文状态：{{lan=="中文"?"你好":'hello'}}-->
      <el-breadcrumb separator="/" class="breadcrumb">
        <el-breadcrumb-item :to="{ path: '/' }">{{ $t("Nav.sy") }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t("Nav.jsyf") }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t("Nav.jsyf_zlbz") }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="contentDiv">
      <div class="leftDiv">
        <el-menu
            default-active="/technology/achievements"
            @select="handleSelect"
            router="true">

          <el-menu-item index="/technology/team"><span>{{ $t("Nav.jsyf_yfdw") }}</span></el-menu-item>
          <el-menu-item index="/technology/patent"><span>{{ $t("Nav.jsyf_yqhz") }}</span></el-menu-item>
          <el-menu-item index="/technology/cooperation"><span>{{ $t("Nav.jsyf_yfcg") }}</span></el-menu-item>
          <el-menu-item index="/technology/achievements"><span>{{ $t("Nav.jsyf_zlbz") }}</span></el-menu-item>
        </el-menu>

      </div>
      <div class="rightDiv">
        <span v-if="lan=='zh'" v-html="info">

        </span>
        <span v-else v-html="infoEN">

        </span>

        <div class="backDiv">
          <el-button size="large" @click="doBack">{{ $t("Comm.back") }}</el-button>
        </div>
      </div>
    </div>
  </div>

</template>

<script setup>
import {ref, toRef, computed, reactive, onMounted} from 'vue'
import {useI18n} from 'vue-i18n'//要在js中使用国际化
import { useStore } from 'vuex'
// import router from "../../router";
import {useRouter} from "vue-router";

const {locale} = useI18n()
const store = useStore()  // 该方法用于返回store 实例

const router = useRouter();

const info =  ""
const infoEN = ""
let lan = computed(() => {
  return locale.value
})



function handleSelect(keyPath) {
  store.state.keyPath=keyPath;
}

function doBack(){
  router.back()
}

// onMounted(() => {

//   // console.log('$router:',router.currentRoute.value.params.id);
// });
onMounted(() => {
  console.log(`the component is now mounted.`)
  // const year = router.currentRoute.value.query.id
  // const year = router.query.id;
    const year = router.currentRoute.value.params.id
  console.log(`接收到的参数：`+year)
})
// onMounted(() => {
//   // const year = router.params.id
//   // console.log(`接收到的参数：`+id)
//
//   console.log(`the component is now mounted.`)
// })
</script>

<style scoped>

.zlBody{
  display: grid;
  grid-template-columns: repeat(4,22%);
  justify-content: space-between;
  grid-row-gap: 2vh;
  margin-top: 2vh;
}

.backDiv{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 3vh;
  --el-color-primary: #D71634;
}


</style>
